module.exports = __webpack_public_path__ + "static/media/modePaiement.088cd732.jpeg";